var _excluded = ["input", "meta", "onLoad", "className", "submitting", "accept", "hidePreview"],
    _excluded2 = ["file", "value", "thumbnail", "previewComponent", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { buttonClasses, fieldPropTypes, hasInputError, isImageType, omitLabelProps } from '../../helpers';
import { LabeledField } from '../../labels';
import FilePreview from './file-preview';
import ImagePreview from './image-preview';
import { noop, generateInputErrorId, isServer } from '../../../utils';
/**
 *
 * A file input that can be used in a `redux-forms`-controlled form. 
 * The value of this input is the data URL of the loaded file. 
 *
 * An optional callback can be fired when the file is loaded: `onLoad(fileData, file)`. 
 * This callback will be passed the data URL of the file, as well as the `File` object itself.
 *
 * By default, this component displays a thumbnail preview of the loaded file. This preview can be customized
 * by using the `thumbnail` or `hidePreview` props, as well as by passing a custom preview via `previewComponent` or `children`.
 *
 * A component passed using `previewComponent` will receive the following props:
 * - `file`: the uploaded file object, or `null` if no file has been uploaded.
 * - `value`: the current value of the input (data URL or empty string)
 * 
 * @name FileInput
 * @type Function
 * @param {Object} input - A `redux-forms` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object
 * @param {Object} meta - A `redux-forms` [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) object
 * @param {Function} [onLoad] - A callback fired when the file is loaded
 * @param {String} [thumbnail] - A placeholder image to display before the file is loaded
 * @param {Boolean} [hidePreview] - A flag indicating whether or not to hide the file preview
 * @example
 * 
 * function HeadshotForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field 
 *          name="headshot" 
 *          component={ FileInput } 
 *          onLoad={ (fileData, file) => console.log('Loaded file!', file) }
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 */

var propTypes = _objectSpread(_objectSpread({}, fieldPropTypes), {}, {
  onLoad: PropTypes.func,
  thumbnail: PropTypes.string,
  hidePreview: PropTypes.bool,
  className: PropTypes.string,
  previewComponent: PropTypes.func,
  children: PropTypes.node
});

var defaultProps = {
  onLoad: noop
}; // Promise wrapper around FileReader

function readFileAsDataUrl(file) {
  // eslint-disable-next-line no-undef
  var fileReader = new window.FileReader();
  return new Promise(function (resolve, reject) {
    // Resolve with file data on success
    fileReader.onload = function (event) {
      return resolve(event.target.result);
    };

    fileReader.onerror = function (error) {
      return reject(error);
    };

    return fileReader.readAsDataURL(file);
  });
}

var FileInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileInput, _React$Component);

  var _super = _createSuper(FileInput);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _super.call(this, props);
    _this.state = {
      file: null
    };
    _this.loadFile = _this.loadFile.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileInput, [{
    key: "loadFile",
    value: function loadFile(e) {
      var _this2 = this;

      // Don't attempt file reading in SSR mode
      if (isServer()) return; // Read file as data URL and call change handlers

      var file = e.target.files[0];
      return readFileAsDataUrl(file).then(function (fileData) {
        return _this2.onChange(fileData, file);
      });
    }
  }, {
    key: "onChange",
    value: function onChange(fileData, file) {
      // Call redux forms onChange and onLoad callback
      var _this$props = this.props,
          onChange = _this$props.input.onChange,
          onLoad = _this$props.onLoad;
      onChange(fileData);
      onLoad(fileData, file);
      this.setState({
        file: file
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _omitLabelProps = omitLabelProps(this.props),
          _omitLabelProps$input = _omitLabelProps.input,
          name = _omitLabelProps$input.name,
          value = _omitLabelProps$input.value,
          meta = _omitLabelProps.meta,
          onLoad = _omitLabelProps.onLoad,
          className = _omitLabelProps.className,
          submitting = _omitLabelProps.submitting,
          accept = _omitLabelProps.accept,
          hidePreview = _omitLabelProps.hidePreview,
          rest = _objectWithoutProperties(_omitLabelProps, _excluded);

      var file = this.state.file;
      var wrapperClass = buttonClasses({
        style: 'secondary-light',
        submitting: submitting
      });
      return (
        /*#__PURE__*/
        React.createElement(LabeledField, this.props,
        /*#__PURE__*/
        React.createElement("div", {
          className: "fileupload fileupload-exists"
        }, !hidePreview && renderPreview(_objectSpread({
          file: file,
          value: value
        }, rest)),
        /*#__PURE__*/
        React.createElement("div", {
          className: wrapperClass
        },
        /*#__PURE__*/
        React.createElement("input", {
          id: name,
          name: name,
          type: 'file',
          onChange: this.loadFile,
          accept: accept,
          'aria-labelledby': name + '-label',
          'aria-describedby': hasInputError(meta) ? generateInputErrorId(name) : null
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: "fileupload-exists",
          id: name + '-label'
        }, " Select File "))))
      );
    }
  }]);

  return FileInput;
}(React.Component); // eslint-disable-next-line react/prop-types


function renderPreview(_ref) {
  var file = _ref.file,
      value = _ref.value,
      thumbnail = _ref.thumbnail,
      Component = _ref.previewComponent,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded2);

  if (Component) return (
    /*#__PURE__*/
    React.createElement(Component, _extends({
      file: file,
      value: value
    }, rest))
  );
  if (children) return children;
  var renderImagePreview = isImageType(file) || thumbnail;
  if (renderImagePreview) return (
    /*#__PURE__*/
    React.createElement(ImagePreview, {
      image: value || thumbnail
    })
  );
  return (
    /*#__PURE__*/
    React.createElement(FilePreview, {
      file: file
    })
  );
}

FileInput.propTypes = propTypes;
FileInput.defaultProps = defaultProps;
export default FileInput;